import { useNavigate, useLocation } from 'react-router-dom'
import { useAppStore } from '../stores/appStore'
import Sidebar from './Sidebar'
import TopNavbar from './TopNavbar'
import ScrollControls from './ScrollControls'

const Layout = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { sidebarOpen, closeSidebar, setCurrentPage } = useAppStore()

  // 页面标题映射
  const pageTitles = {
    '/': '账号管理',
    '/account-management': '账号管理',
    '/daily-tasks': '日常任务'
  }

  const currentPageTitle = pageTitles[location.pathname] || '暴走无双辅助'

  // 处理页面切换
  const handlePageChange = (path) => {
    navigate(path)
    setCurrentPage(path.replace('/', '') || 'account-management')
    
    // 在移动端关闭侧边栏
    if (window.innerWidth <= 768) {
      closeSidebar()
    }
  }

  return (
    <div className="app-layout">
      <Sidebar onPageChange={handlePageChange} currentPath={location.pathname} />
      
      {/* 侧边栏遮罩层 */}
      <div 
        className={`sidebar-overlay ${sidebarOpen ? 'show' : ''}`}
        onClick={closeSidebar}
      />

      {/* 主内容区域 */}
      <div className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <TopNavbar title={currentPageTitle} />
        
        <div className="page-content">
          {children}
        </div>
      </div>

      <ScrollControls />
    </div>
  )
}

export default Layout
